import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

import swal from 'sweetalert2';
import {HttpService} from '../http-utility/http.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  @ViewChild('recaptcha', {read: ElementRef}) recaptchaElement: ElementRef;

  // passwordAgenti = 'OrionAgenti2018';
  // passwordAgenti = 'aGenTiOriOn.2020';
  // passwordAgenti = 'usatiORION.2020';
  passwordAgenti = 'usatiORION.2022';

  width = document.documentElement.clientWidth;
  margin;
  logo: string;

  modalLogin: boolean;
  password: string;
  loggato: boolean;

  modalContatti: boolean;
  province: Array<any> = [];
  nome: string;
  associazione: string;
  telefono: string;
  mail: string;
  provincia: string;
  nota: string;
  captcha: string;

  constructor(private service: HttpService) {
    this.logo = 'assets/img/logo.jpg';

    this.modalLogin = false;
    
  }

  async ngOnInit(): Promise<void> {
    this.closeContatti();

    this.loggato = localStorage.getItem('orion-usati-password') && localStorage.getItem('orion-usati-password') === '1' ? true : false;

    const result = await this.service.ricerca<any>('province/', null).toPromise();
    this.province =  result.data;
  }

  login() {
    this.modalLogin = true;
  }

  entra() {
    if (this.password && this.password === this.passwordAgenti) {
      localStorage.setItem('orion-usati-password', '1');
      this.loggato = true;
      this.closeLogin();
      location.reload();
    } else {
      swal.fire('Errore!', 'Password non valida!', 'error');
    }
  }

  closeLogin() {
    this.modalLogin = false;
  }

  logout() {
    localStorage.setItem('orion-usati-password', '0');
    this.loggato = false;
    location.reload();
  }

  openContatti() {
    const pratica = localStorage.getItem('orion-usati-pratica');

    if (!pratica) {
      this.nota = 'Spett.le Orion,\n' +
        'sono interessato ad un veicolo con le seguenti caratteristiche:';
    } else {
      this.nota = 'Spett.le Orion,\n' +
        ' vorrei informazioni riguardo la pratica n. ' + pratica;
    }

    this.modalContatti = true;
  }

  closeContatti() {
    this.nome = '';
    this.associazione = '';
    this.telefono = '';
    this.mail = '';
    this.provincia = '';
    this.nota = '';
    this.captcha = '';

    this.modalContatti = false;
  }

  async invioContatto(): Promise<void> {
    if (!this.nome) {
      swal.fire('Errore!', 'Inserire il nome e il cognome!', 'error');
      return;
    }
    if (!this.associazione) {
      swal.fire('Errore!', 'Inserire il nome dell\'associazione!', 'error');
      return;
    }
    if (!this.mail) {
      swal.fire('Errore!', 'Inserire l\'indirizzo e-mail', 'error');
      return;
    }
    if (!this.provincia) {
      swal.fire('Errore!', 'Inserire la provincia!', 'error');
      return;
    }
    if (!this.nota) {
      swal.fire('Errore!', 'Inserire la nota!', 'error');
      return;
    }
    // CAPTCHA
    if (!this.captcha) {
      swal.fire('Errore!', 'Seleziona il captcha se non sei un robot!', 'error');
      return;
    }

    // INVIO DELLA MAIL
    await this.service.ricerca('usati/0/web/contatto/', {
      nome: this.nome,
      associazione: this.associazione,
      telefono: this.telefono,
      mail: this.mail,
      provincia: this.provincia,
      nota: this.nota
    }).toPromise();
    this.closeContatti();
    
  }

  resolved(captchaResponse: string) {
    // console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.captcha = captchaResponse;
  }
}
